import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./locales/en/translation.json";
import hiTranslation from "./locales/hi/translation.json";
import mrTranslation from "./locales/mr/translation.json"; // Marathi
import guTranslation from "./locales/gu/translation.json"; // Gujarati
import knTranslation from "./locales/kn/translation.json"; // Kannada
import taTranslation from "./locales/ta/translation.json"; // Tamil
import paTranslation from "./locales/pa/translation.json";
import bnTranslation from "./locales/bn/translation.json";
import orTranslation from "./locales/or/translation.json";
import teTranslation from "./locales/te/translation.json";


i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    hi: { translation: hiTranslation },
    mr: { translation: mrTranslation },
    gu: { translation: guTranslation },
    kn: { translation: knTranslation },
    ta: { translation: taTranslation },
    pa: { translation: paTranslation },
    te: { translation: teTranslation },
    bn: { translation: bnTranslation },
    or: { translation: orTranslation },
  },
  lng: "en", // Default language
  fallbackLng: "en", // Fallback language
  interpolation: { escapeValue: false }, // React already escapes values
});

export default i18n;